import { defineStore } from "pinia";
import { Filiale } from "@/models/filiale";

export interface FilialeSelection {
  filiale: Filiale;
  pos: number;
}

export interface FilialeState {
  provincia: string | undefined;
  filiale: FilialeSelection | undefined;
  filiali: Array<Filiale>;
}

export const useBookingStore = defineStore("booking", {
  state: (): FilialeState => ({
    provincia: undefined,
    filiale: undefined,
    filiali: [],
  }),
  getters: {
    Provincia: (state): string | undefined => state.provincia,
    Filiale: (state): FilialeSelection | undefined => state.filiale,
    Filiali: (state): Array<Filiale> => state.filiali,
  },
  actions: {
    SET_PROVINCIA(p?: string): void {
      this.provincia = p;
    },
    SET_FILIALE(f?: FilialeSelection): void {
      this.filiale = f;
    },
    SET_FILIALI(ff: Array<Filiale>): void {
      this.filiali = ff;
    },
  },
});
